
// src/components/common/TrialBanner.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../../context/SubscriptionContext';
import './TrialBanner.css';

function TrialBanner() {
  const navigate = useNavigate();
  const { accessStatus } = useSubscription();

  // Don't show if no subscription data
  if (!accessStatus) {
    return null;
  }

  const daysRemaining = accessStatus.daysRemaining;
  const status = accessStatus.status || accessStatus.reason;
  const plan = accessStatus.plan || 'Starter';

  if (daysRemaining > 7) {
    return null;
  }

  // Determine banner type and content
  let bannerClass = 'trial-banner';
  let icon = '🎉';
  let title = 'Free Trial Active';
  let message = '';
  let buttonText = 'Upgrade Now';

  const isExpired = daysRemaining < 0;
  const expiringToday = daysRemaining === 0;
  const expiringSoon = daysRemaining > 0 && daysRemaining <= 7;
  const isTrial = status === 'trial';

  if (isExpired) {
    bannerClass += ' expired';
    icon = '❌';
    title = 'Subscription Expired';
    message = `Expired ${Math.abs(daysRemaining)} ${Math.abs(daysRemaining) === 1 ? 'day' : 'days'} ago`;
    buttonText = 'Reactivate Now';
  } else if (expiringToday) {
    bannerClass += ' urgent';
    icon = '⚠️';
    title = isTrial ? 'Trial Ends Today!' : 'Subscription Expires Today!';
    message = `Expires today`;
    buttonText = isTrial ? 'Upgrade Now' : 'Renew Now';
  } else if (expiringSoon) {
    bannerClass += ' urgent';
    icon = '⚠️';
    title = isTrial ? 'Trial Ending Soon!' : 'Subscription Expiring Soon!';
    message = `${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'} remaining`;
    buttonText = isTrial ? 'Upgrade Now' : 'Renew Now';
  } else if (isTrial) {
    bannerClass += ' trial';
    icon = '🎉';
    title = 'Free Trial Active';
    message = `${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'} remaining`;
    buttonText = 'Upgrade Now';
  }

  const handleUpgrade = () => {
    navigate('/subscribe');
  };

  return (
    <div className={bannerClass}>
      <div className="trial-content">
        <span className="trial-icon">{icon}</span>
        <div className="trial-text">
          <strong>{title}</strong>
          <p>
            {message} · {plan} Plan
            {accessStatus.endDate && ` · Expires ${new Date(accessStatus.endDate).toLocaleDateString()}`}
          </p>
        </div>
        <button onClick={handleUpgrade} className="btn-upgrade">
          {buttonText}
        </button>
      </div>
    </div>
  );
}

export default TrialBanner;